// @ts-nocheck - TODO: Fix form element types and quick link data structure
import { useState, useEffect } from 'react';
import { Col, Row, Form, Modal, Button } from 'react-bootstrap';

import BayWidgetLoadingPlaceholder from '../../BayWidgetLoadingPlaceholder';
import { getValidUrl } from '../../utilities/otherFuncs';
import { urlRegex } from '../../utilities/regex';
import type { TranslationFunction } from '../../types/common';

import BayFieldWithSpinner from './BayFieldSpinner';
import isActingAsAnotherUser from './isActingAsAnotherUser';

interface LinkItem {
	id?: number;
	publicid?: string;
	src?: string;
	label?: string;
	Label?: string;
	web_src?: string;
	sso_src?: string;
	title?: string;
	btnText?: string;
	description?: string;
	ssoLogin_params?: string;
	singleSignOn_Parameters?: string;
}

interface LinksArray {
	quicklinks?: Array<{
		src: string;
		label: string;
	}>;
}

interface SsoLink {
	value?: string;
	label?: string;
}

interface User {
	ActingAsPUBLICID: string;
	PUBLICID: string;
	ActingAsBAY_PARENT_ACCOUNT_ID?: string;
	_companyid?: string;
	parent_account_id?: string;
}

interface QuickLinkService {
	linksConnectReconnect: (params: any) => Promise<any>;
	updatePersonalSSOLink: (params: any) => Promise<any>;
	quickLinkLogin: (params: any) => Promise<any>;
	processPersonalAndWebLinks: (params: any) => Promise<any>;
	updatePersonalSSOLayout: (params: any) => Promise<any>;
}

interface QuickLinksModalProps {
	showModal: boolean;
	onHideFunc: (type: string) => void;
	modalType: string;
	user?: User;
	linkItem?: LinkItem;
	linksArray?: LinksArray;
	setShowOffCanvas?: (show: boolean) => void;
	ssoIdLinks?: SsoLink[];
	editQuickLinksDataUser?: any;
	globalQLData?: any;
	fetchQuickLinksCallBack?: () => void;
	setShowSnackbarHandler?: (message: string, type?: string) => void;
	isUpdateSSO?: boolean;
	openModalFunc?: (type: string, item: LinkItem, flag: boolean) => void;
	t?: TranslationFunction;
	quickLinkService?: QuickLinkService;
}

const QuickLinksModal = ({
	showModal,
	onHideFunc,
	modalType,
	user,
	linkItem,
	linksArray,
	setShowOffCanvas,
	ssoIdLinks,
	editQuickLinksDataUser,
	globalQLData,
	fetchQuickLinksCallBack,
	setShowSnackbarHandler,
	isUpdateSSO,
	openModalFunc,
	t,
	quickLinkService,
}: QuickLinksModalProps) => {
	const [linkUrl, setLinkUrl] = useState('');
	const [ssoLink, setSsoLink] = useState<SsoLink | null>(null);
	const [loading, setLoading] = useState(false);
	const [linkLabel, setLinkLabel] = useState('');
	const [linkSelected, setLinkSelected] = useState('W');
	const [validatedUrl, setValidatedUrl] = useState(false);
	const [isUrlFieldLoading, setIsUrlFieldLoading] = useState(false);
	const [validateMessage, setValidateMessage] = useState({
		label: '',
		url: '',
	});

	const handleSubmit = async () => {
		if (modalType === 'connectionStatus') {
			if (isUpdateSSO) {
				onHideFunc('link');
				linkItem.title = t('unableToReconnect');
				linkItem.btnText = t('update');
				linkItem.description = t('updateMySSODesc');
				openModalFunc('updatePersonalSso', linkItem, true);
			} else {
				try {
					const Response = await quickLinkService.linksConnectReconnect({
						publicid:
							linkItem?.publicid === 'Global' || linkItem?.publicid === 'global'
								? 'global'
								: user?.ActingAsPUBLICID,
						selectedlist: linkItem?.src,
						action: linkItem?.btnText,
					});
					if (Response?.STATUS === 0) {
						fetchQuickLinksCallBack();
						setShowSnackbarHandler(Response?.MESSAGE);
						onHideFunc('link');
					} else {
						setShowSnackbarHandler(Response?.MESSAGE, 'danger');
					}
				} catch (error) {
					console.error('Error:', error);
				}
			}
		}

		if (modalType === 'updatePersonalSso') {
			const ModalformData = new FormData(
				document.getElementById('quicklinks_dataform'),
			);
			const formValues = Object.fromEntries(ModalformData.entries());
			const loginParams = linkItem?.ssoLogin_params
				? linkItem?.ssoLogin_params
				: globalQLData?.ssoLogin_params;
			const SSOParams = linkItem?.singleSignOn_Parameters?.length
				? linkItem?.singleSignOn_Parameters
				: '{}';
			const userParams = editQuickLinksDataUser?.ssoLogin_params?.length
				? editQuickLinksDataUser?.ssoLogin_params
				: '{}';
			const userParamsObj = JSON.parse(userParams);
			try {
				quickLinkService
					.updatePersonalSSOLink({
						publicId: user?.ActingAsPUBLICID,
						sso_src: linkItem?.src,
						label: ssoLink?.label,
						params: loginParams,
						ssoParams: SSOParams,
						dbAction: Object.keys(userParamsObj)?.length ? 'update' : 'create',
						ssoType: ssoLink?.label,
						oDataFields: formValues,
						loginParamsObj: formValues,
					})
					.then((Response) => {
						if (Response?.STATUS === 0) {
							quickLinkService
								.quickLinkLogin({ sso_src: linkItem?.src })
								.then((res) => {
									if (res?.STATUS === 0) {
										if (!isActingAsAnotherUser(user)) {
											if (res?.isSamlRequest) {
												const url = String(res?.URL || '');
												if (!/^https?:\/\//i.test(url)) {
													setShowSnackbarHandler(t('invalidUrlNote'), 'danger');
													return;
												}
												const newTab = window.open(url, '_blank', 'noopener,noreferrer');
												if (newTab) newTab.opener = null;
											} else {
												const layout = document.createElement('div');
												layout.innerHTML = res.LAYOUT;
												document.body.appendChild(layout);
												document.getElementById('quicklinks_form').submit();
												document.getElementById('quicklinks_form').remove();
											}
										}
										setShowSnackbarHandler(res?.MESSAGE);
									} else {
										setShowSnackbarHandler(res?.MESSAGE, 'danger');
									}
									fetchQuickLinksCallBack();
									onHideFunc('link');
								});
						} else {
							setShowSnackbarHandler(Response?.MESSAGE, 'danger');
						}
					});
			} catch (error) {
				console.error('Error:', error);
			}
		}

		if (
			linkSelected !== 'S' &&
			!linkUrl.match('sso:') &&
			(modalType === 'editPersonalLink' || modalType === 'addPersonalLink')
		) {
			const url = new URL(linkUrl);
			// Check if any of our links src is equal to:
			// Entire new string...
			// just the origin (https://backatyou.com)...
			// without the protocol (backatyou.com)...
			// and just the host (may include a port number).
			const filteredLinkObject = linksArray?.quicklinks?.find((e) => {
				return (
					e.src === url.href ||
					// e.src === url.origin ||   //check the condtion with www and without www for same link
					e.src ===
						(url.protocol
							? url.origin.substring(url.protocol === 'https:' ? 8 : 7)
							: url.origin) ||
					e.src === url.hostname
				);
			});

			if (filteredLinkObject && linkItem?.src !== filteredLinkObject?.src) {
				setValidatedUrl(false);
				setValidateMessage((prevMessage) => ({
					...prevMessage,
					url: `This link URL already exists and is labeled as ${filteredLinkObject?.label}`,
				}));
				return;
			}
		}

		let formData = {
			sso_src: '',
			link_type: 'W',
			target: '_blank',
			ReturnFormat: 'json',
			Method: 'ProcessLinks',
		};
		if (modalType === 'editPersonalLink') {
			try {
				formData = {
					...formData,
					label: linkLabel,
					web_src: decodeURI(linkUrl),
					action: 'update',
					publicid: user.ActingAsPUBLICID,
					OrigSRC: linkItem?.src,
				};
				await quickLinkService
					.processPersonalAndWebLinks({ linkFormData: formData })
					.then((res) => {
						if (res.STATUS === 0) {
							setShowSnackbarHandler(res?.MESSAGE);
							fetchQuickLinksCallBack();
						} else {
							setShowSnackbarHandler(res?.MESSAGE, 'danger');
						}
						onHideFunc('link');
					});
			} catch (error) {
				console.log(error);
			}
		}

		if (modalType === 'addPersonalLink') {
			try {
				formData = {
					...formData,
					label: linkLabel,
					web_src: decodeURI(linkUrl),
					action: 'create',
					publicid: user.ActingAsPUBLICID,
					OrigSRC: '',
				};
				await quickLinkService
					.processPersonalAndWebLinks({ linkFormData: formData })
					.then((res) => {
						if (res.STATUS === 0) {
							setShowSnackbarHandler(res?.MESSAGE);
							fetchQuickLinksCallBack();
						} else {
							setShowSnackbarHandler(res?.MESSAGE, 'danger');
						}
						onHideFunc('link');
					});
			} catch (error) {
				console.log(error);
			}
		}
	};

	useEffect(() => {
		if (showModal) {
			setLinkUrl('');
			setLinkLabel('');
			setLinkSelected('W');
			setSsoLink(null);
		}
	}, []);

	useEffect(() => {
		if (linkItem?.label?.length) {
			if (modalType.includes('edit')) {
				if (
					linkItem?.sso_src !== undefined &&
					linkItem?.sso_src?.includes('sso:')
				) {
					setLinkSelected('S');
				} else {
					setLinkSelected('W');
				}

				if (linkItem) {
					const linkData = linkItem?.web_src ?? linkItem?.src;
					if (linkData?.length >= 1) {
						setLinkUrl(linkData);
					} else {
						setLinkUrl('');
					}
				}
				const Label = linkItem?.label || linkItem?.Label;

				if (Label?.length) {
					setLinkLabel(Label);
				}
			}
		}
		const fetchLayout = async () => {
			setLoading(true);
			const Response = await quickLinkService.updatePersonalSSOLayout({
				publicid: 'global',
				sso_src: linkItem.src.startsWith('sso:') ? linkItem.src : '',
				action: 'create',
			});
			setLoading(false);
			if (Response?.STATUS === 0) {
				document.getElementById('StatusQuick').innerHTML = Response?.LAYOUT;
			}
			if (linkItem?.src?.includes('sso:')) {
				const sourceUrl = linkItem?.src;
				const filteredArr = ssoIdLinks.filter(
					(val) => val?.value === sourceUrl,
				);
				if (filteredArr?.length) {
					setSsoLink(filteredArr[0]);
				}
			}
		};
		if (modalType === 'updatePersonalSso') {
			fetchLayout();
		}
	}, [isUpdateSSO, modalType, linkItem]);

	useEffect(() => {
		if (modalType === 'editPersonalLink') {
			setValidatedUrl(true);
		}
	}, [modalType, linkItem]);

	const checkValidField = async (fieldName, value) => {
		let errorMessage = '';
		if (fieldName === 'label') {
			errorMessage = !value?.trim()?.length ? t('linkCannotBlank') : '';
			setValidateMessage((prevMessage) => ({
				...prevMessage,
				label: errorMessage,
			}));
			return;
		} else {
			const url = value.trim();
			if (!url?.length) {
				setValidatedUrl(false);
				errorMessage = t('urlCannotBlank');
			} else if (urlRegex.test(url)) {
				const response = await getValidUrl(url, setIsUrlFieldLoading);
				if (response.STATUS === 0) {
					setLinkUrl(response.validURL);
					setValidatedUrl(true);
				} else if (response.STATUS === 2) {
					errorMessage = t('invalidUrlNote');
				}
			} else {
				setValidatedUrl(false);
				errorMessage = t('invalidUrlNote');
			}
			setValidateMessage((prevMessage) => ({
				...prevMessage,
				url: errorMessage,
			}));
		}
	};

	return (
		<Modal
			backdrop="static"
			className={`bay-link-modal quicklinks-modal ${modalType === 'connectionStatus' ? 'ssoConnectionModal' : 'ssoModal'}`}
			show={showModal}
			onHide={() => {
				setShowOffCanvas(true);
				onHideFunc('link');
			}}
		>
			<Modal.Header
				className={`${modalType === 'connectionStatus' ? '' : 'border-bottom'}`}
				closeButton={modalType !== 'connectionStatus' ? true : false}
			>
				<Modal.Title>
					<span className="titleFontSize">{linkItem?.title}</span>
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="pt-3">
				<Row className="d-flex align-items-center">
					<Col xs={12}>
						<p className="mb-2 text-black-heading">
							{linkItem?.description ?? ''}
						</p>
						{modalType === 'updatePersonalSso' && isUpdateSSO && (
							<p
								className="bg-yellow-200 fw-bold p-2"
								style={{ borderRadius: '5px' }}
							>
								{t('updateSsoConnectionWarning')}
							</p>
						)}
						<Form
							noValidate
							id="quicklinks_dataform"
							name="QuickLinks Dataform"
							onSubmit={handleSubmit}
						>
							{modalType === 'updatePersonalSso' && (
								<Form.Group className="mt-2" controlId="linkLabel">
									<div className="mt-3">
										<Form.Label>
											<div className="d-flex text-black-heading fw-bold">
												{t('sso')}
											</div>
											<div className="mt-2 fw-normal text-capitalize">
												{ssoLink?.label}
											</div>
										</Form.Label>
									</div>
									{loading && <BayWidgetLoadingPlaceholder />}
									<Form.Group className="sso_details" id="StatusQuick" />
								</Form.Group>
							)}

							{(linkItem?.id === 1 || linkItem?.id === 2) &&
							modalType !== 'updatePersonalSso' &&
							modalType !== 'connectionStatus' ? (
									<>
										<Form.Group className="mb-4" controlId="linkLabel">
											<Form.Label className="d-flex justify-content-between">
												<div className="text-black-heading required">
													{t('labelForDisplay')}
												</div>
												<span className="text-500 fw-normal">
													{linkLabel?.length} / 40
												</span>
											</Form.Label>
											<Form.Control
												id="label"
												isInvalid={validateMessage?.label?.length > 0}
												maxLength={40}
												name="label"
												placeholder={t('labelPlaceholder')}
												value={linkLabel}
												onBlur={(e) =>
													checkValidField(e.target.id, e.target.value)
												}
												onChange={(e) => {
													setLinkLabel(e.target.value);
													setValidateMessage((prevMessage) => ({
														...prevMessage,
														label: '',
													}));
												}}
											/>
											<Form.Control.Feedback
												className={
													validateMessage?.label?.length > 0 ? 'd-block' : ''
												}
												type="invalid"
											>
												{validateMessage?.label}
											</Form.Control.Feedback>
										</Form.Group>
										{linkSelected !== 'S' && (
											<Form.Group controlId="linkURLAddress">
												<Form.Label className="d-flex justify-content-between">
													<div className="text-black-heading required">
														{t('toWhatUrlLinkgo')}
													</div>
													{!validatedUrl ? (
														<span className="text-400 fw-normal">
															{t('testThisLink')}
														</span>
													) : (
														<a
															className="text-blue fw-normal"
															href={linkUrl}
															target="_blank" rel="noreferrer"
														>
															{t('testThisLink')}
														</a>
													)}
												</Form.Label>
												<BayFieldWithSpinner
													required
													id="web_src"
													isFieldLoading={isUrlFieldLoading}
													isInvalid={validateMessage?.length > 0}
													maxLength={512}
													minLength={4}
													name="web_src"
													placeholder={t('websitePlaceholder')}
													value={linkUrl}
													onBlurFunc={(e) =>
														!validatedUrl &&
													!validateMessage?.length &&
													checkValidField(e.target.id, e.target.value)
													}
													onChangeFunc={(e) => {
														setLinkUrl(e.target.value);
														setValidatedUrl(false);
														setValidateMessage((prevMessage) => ({
															...prevMessage,
															url: '',
														}));
													}}
												/>
												<Form.Control.Feedback
													className={
														validateMessage?.url?.length > 0 ? 'd-block' : ''
													}
													type="invalid"
												>
													{validateMessage?.url}
												</Form.Control.Feedback>
											</Form.Group>
										)}
									</>
								) : null}
						</Form>
					</Col>
				</Row>
			</Modal.Body>
			<Modal.Footer className="mt-5">
				<button
					className="btn btn-outline-600"
					onClick={() => {
						setShowOffCanvas(true);
						onHideFunc('link');
					}}
				>
					{t('cancel')}
				</button>
				<Button
					disabled={
						modalType === 'connectionStatus'
							? false
							: modalType === 'updatePersonalSso'
								? false
								: (linkSelected !== 'S' &&
										(linkLabel?.length <= 0 ||
											linkUrl?.length <= 0 ||
											!validatedUrl ||
											validateMessage?.name?.length ||
											validateMessage?.url?.length)) ||
									(linkSelected === 'S' && !ssoLink?.value?.length) ||
									loading
					}
					variant={
						linkItem?.btnText === 'Disconnect'
							? 'danger'
							: linkItem?.btnText === 'Reconnect'
								? 'success'
								: 'primary'
					}
					onClick={() => {
						handleSubmit();
						setShowOffCanvas(true);
					}}
				>
					{linkItem?.btnText}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default QuickLinksModal;
